import { gsap } from 'gsap';

export default function () {
  const header = document.querySelector('[data-header]');
  const headerAnimationEvent = new Event('headerAnimationDone');

  if (header) {
    const mm = gsap.matchMedia();
    const toggleViewBreakPoint = 576;

    let isPreloaderDone = false;
    document.addEventListener('preloaderDone', () => {
      isPreloaderDone = true;
    });

    const showHeader = () => {
      gsap.to(header, {
        x: 0,
        y: 0,
        duration: 0.3,
        clearProps: 'all',
        onComplete: () => {
          gsap.delayedCall(0.3, () => document.dispatchEvent(headerAnimationEvent));
        },
      });
    };

    mm.add({
      isMobile: `(max-width: ${toggleViewBreakPoint - 1}px)`,
      isDesktop: `(min-width: ${toggleViewBreakPoint}px)`,
    }, (context) => {
      const { isMobile } = context.conditions;

      gsap.set(header, {
        x: isMobile ? 0 : -100,
        y: isMobile ? -100 : 0,
      });

      if (isPreloaderDone || sessionStorage.getItem('preloaderDone')) {
        showHeader();
      } else {
        document.addEventListener('preloaderDone', () => {
          showHeader();
        });
      }
    });
  }
}
